module.exports = {
  postOnboardingSurveyEvents: {
    POSurvey: {
      code: 'POQuickSurvey',
      events: {
        POQuickSurvey_DisplayToUser: {
          description: 'Survey is displayed to the user.',
          eventHub: {
            action: 'POQuickSurvey_DisplayToUser'
          }
        },
        POQuickSurvey_Submit: {
          description: 'User submits the survey.',
          eventHub: {
            action: 'POQuickSurvey_Submit'
          }
        },
        POQuickSurvey_Close: {
          description: 'User closes the survey.',
          eventHub: {
            action: 'POQuickSurvey_Close'
          }
        },
        POQuickSurvey_ExitSurvey: {
          description: 'User exits the survey by clicking outside the popup.',
          eventHub: {
            action: 'POQuickSurvey_ExitSurvey'
          }
        },
        POQuickSurvey_Complete: {
          description: 'User completes the survey by clicking "Done".',
          eventHub: {
            action: 'POQuickSurvey_Complete'
          }
        }
      }
    }
  }
};
